import React from 'react'
import { Box, VStack, Text, Button, Container, Icon } from '@chakra-ui/react'
import { AlertTriangle } from 'lucide-react'
import { useLanguage } from '../../hooks/utility/useLanguage'

export interface ErrorStateProps {
  message?: string
  actionText?: string
  onAction?: () => void
  useContainer?: boolean
  bg?: string
  minHeight?: string
  showIcon?: boolean
}

const ErrorState: React.FC<ErrorStateProps> = ({
  message,
  actionText,
  onAction,
  useContainer = false,
  bg = 'app.bg',
  minHeight = '50vh',
  showIcon = true
}) => {
  const { t } = useLanguage()

  const defaultMessage = message || t('common.error')
  const defaultActionText = actionText || t('common.tryAgain')

  const content = (
    <Box
      bg={bg}
      minH={minHeight}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <VStack spacing={4}>
        {showIcon && (
          <Icon
            as={AlertTriangle}
            boxSize={12}
            color="red.500"
          />
        )}
        <Text
          color="red.500"
          fontSize="lg"
          textAlign="center"
          maxW="md"
        >
          {defaultMessage}
        </Text>
        {onAction && (
          <Button
            onClick={onAction}
            colorScheme="primaryScheme"
            variant="outline"
          >
            {defaultActionText}
          </Button>
        )}
      </VStack>
    </Box>
  )

  if (useContainer) {
    return (
      <Container maxW="container.xl" py={8}>
        {content}
      </Container>
    )
  }

  return content
}

export default ErrorState
